import { YammerCache } from './types';

export default class MemoryStorage implements YammerCache {
  private items: Record<string, unknown>;

  constructor() {
    this.items = {};
  }

  public getItem<T>(key: string): T | null {
    return (this.items[key] as T) || null;
  }

  public setItem<T>(key: string, value: T): void {
    this.items[key] = value;
  }

  public removeItem(key: string): void {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete this.items[key];
  }

  public clear(): void {
    this.items = {};
  }
}
